<template>
  <div class="cy-user-manage">
    <div class="content">
      <div class="conditon">
        <OperationBtns
          class="operation-btns"
          @clickBtn="handleCommand"
          :btn-data="btnData"
          :select-length="selectedData.length"
        />
        <!-- <el-button
          v-for="(item, index) in btnArr"
          :key="index"
          :disabled="!isMedia"
          :title="!isMedia ? '权限不足' : ''"
          @click="handleCommand({ flag: item.label })"
        >
          {{ item.name }}
        </el-button> -->
      </div>
      <div class="list">
        <commonTable
          ref="userList"
          :thead="thead"
          empty="当前未查询到任何角色数据"
          :tpropty="tpropty"
          :table-data="userList"
          :is-show-section="true"
          @handleCommand="handleCommand"
          @handleSelectionChange="handleSelectionChange"
        />
      </div>
    </div>
    <el-pagination
      background
      layout="slot,prev, pager, next"
      :total="total"
      :page-size="pagesize"
      :current-page="page"
      @current-change="getList"
      v-show="userList.length !== 0"
    >
      <span class="total">
        共
        <em>{{ total }}</em>条信息
      </span>
    </el-pagination>
    <addRoleDialog
      ref="addRoleDialog"
      :is-alter="isAlter"
      :menu-data="menuData"
      :menu-list="roleMenus"
      :role-operation="roleOperation"
      :default-props="defaultProps"
      @dialogSure="getUserSave"
      @getRoleMenusOperations="getRoleMenusOperations"
    />
    <delRoleDialog
      ref="delRoleDialog"
      title="删除确认"
      :is-show-footer="isCanDelete"
      width="450px"
      @dialogSure="deleteUser"
    >
      <div class="delete-icon-box">
        <i class="icon icon-warning" />
      </div>
      <div class="delete-text">
        {{ deleteTips }}
      </div>
    </delRoleDialog>
    <!-- <delRoleDialog :deleteTips="deleteTips"></delRoleDialog> -->
  </div>
</template>

<script>
import APIS from '@apis/settings.js'
import addRoleDialog from './components/addRole.vue'
import commonTable from './components/list.vue'
import delRoleDialog from './components/dialog'
// import delRoleDialog from '../category/components/dialog'
import OperationBtns from '@components/common/operationBtns'
export default {
  name: 'CyUserManage',
  components: {
    addRoleDialog,
    delRoleDialog,
    commonTable,
    OperationBtns
  },
  data() {
    return {
      isCanDelete: true,
      menuData: [],
      storeMenu: [],
      btnData: [
        { code: 'settings_roles_add', name: '新增角色', isShow: false, operation: 'add' },
        { code: 'settings_roles_edit', name: '修改', isShow: false, operation: 'edit' },
        { code: 'settings_roles_delete', name: '批量删除', isShow: false, operation: 'delete' }
      ],
      btnArr: [
        {
          label: 'add',
          name: '新增角色'
        },
        {
          label: 'multiDel',
          name: '批量删除'
        }
      ],
      thead: [{ label: '序号', width: 50 }, '角色名称', '角色类型'],
      tpropty: ['index', 'name', 'type'],
      userList: [],
      total: 0,
      page: 1,
      pagesize: 10,
      isMedia: false,
      isAlter: false,
      deleteTips: '',
      delIds: '',
      roleTypeObj: {
        1: '媒体管理员',
        2: '媒体普通用户',
        3: '自定义',
        4: '区域管理员'
      },
      selectedData: [],
      // add role dialog -- operation auth
      roleMenus: [],
      defaultProps: { label: 'name', children: 'children' },
      roleOperation: [],
      menusOperation: {}
    }
  },
  computed: {},
  created() {
    this.$store.commit('UPDATE_BreadMenuData', [])
    let userInfor = login_cookie['userType']
    this.isMedia = userInfor === 1 || userInfor === 4
    // this.$store.commit('UPDATE_BreadMenuData', ['角色管理'])
    this.getMenu()
    this.getList()
    // add role dialog -- operation auth
  },
  methods: {
    // 菜单列表
    async getMenu() {
      let { status, data } = await APIS.postUserRoleMenu()
      if (status === 0 && data && data.length !== 0) {
        this.menuData = data.map((item) => {
          return {
            id: item.id,
            name: item.name,
            selected: false,
            children: item.children
              .map((subItem) => {
                return {
                  id: subItem.id,
                  type: subItem.url ? 1 : 2,
                  name: subItem.name,
                  selected: false
                }
              })
              .sort((a, b) => {
                return a.type - b.type
              })
          }
        })
        this.storeMenu = JSON.stringify(this.menuData)
      } else {
        this.menuData = []
      }
    },
    // 角色列表
    async getList(value) {
      this.page = value || 1
      let params = {
        page: this.page,
        pagesize: this.pagesize
      }
      let { status, data } = await APIS.postUserRoleSearch({ data: params })
      this.total = 0
      if (status === 0 && data && data.result && data.result.length !== 0) {
        this.total = data.total
        this.userList = data.result.map((item, index) => {
          return {
            index: index + (this.page - 1) * this.pagesize + 1,
            id: item.id,
            name: item.name,
            type: this.roleTypeObj[item.roleType],
            media: item.media,
            btnOperate: this.isMedia && item.roleType !== 1 && item.roleType !== 4,
            roleType: item.roleType
          }
        })
      } else {
        this.userList = []
      }
    },
    // 增加或者修改用户
    async getUserSave(val) {
      let usrinfo = this.$refs.addRoleDialog.userForm
      let menusOperationResult = []
      for (let key in this.menusOperation) {
        let arr = this.getOperationIds(this.menusOperation[key])
        menusOperationResult.push({ menuId: key, operationIds: arr })
      }
      let params = {
        id: usrinfo.id,
        name: usrinfo.name,
        roleType: usrinfo.roleType,
        menus: val.length === 0 ? '[]' : JSON.stringify(val),
        operations: JSON.stringify(menusOperationResult)
      }
      let { status, message } = await APIS.postUserRoleSave({ data: params })
      if (status === 0) {
        this.getList()
        this.$refs.addRoleDialog.$refs.dialog.cyDialogCommon = false
      } else {
        this.handleMessageTips(message, 'error')
      }
    },
    async deleteUser() {
      let { status, message } = await APIS.postUserRoleDelete({
        data: { ids: this.delIds }
      })
      if (status === 0) {
        this.getList()
        this.$refs.delRoleDialog.cyDialogCommon = false
      } else {
        this.handleMessageTips(message, 'error')
      }
    },
    // 角色信息
    async getUserRoleForm(value) {
      let { status, data } = await APIS.postUserRoleForm({ data: { id: value } })
      if (status === 0) {
        this.menuData.forEach((item, index) => {
          item.children.forEach((subItem, subIndex) => {
            let selectedIndex = JSON.parse(data.customerRoleMenus).indexOf(subItem.id)
            subItem.selected = selectedIndex !== -1
          })
        })
      }
    },
    handleSelectionChange(ids) {
      this.selectedData = ids
    },
    // 增删改
    handleCommand(userInfo) {
      if (userInfo === 'delete') {
        let multi = this.selectedData.length > 1
        this.isCanDelete = !(multi && this.selectedData.length === 0)
        this.deleteTips = this.selectedData.length === 1 ? '您确定要删除吗？' : '您确定要删除' + this.selectedData.length + '个角色吗？'
        this.delIds = multi ? this.selectedData.join(',') : this.selectedData[0]
        this.$refs.delRoleDialog.cyDialogCommon = true
      } else {
        this.isAlter = userInfo === 'edit'
        this.$refs.addRoleDialog.$refs.dialog.cyDialogCommon = true
        this.$nextTick(() => {
          let editUser
          this.userList.forEach((item) => {
            if (item.id === this.selectedData[0]) {
              editUser = item
            }
          })
          this.$refs.addRoleDialog.initParmas(this.isAlter ? editUser : {})
          this.$refs.addRoleDialog.currentAuthSelect = 'menu'
          this.roleOperation = []
          this.menusOperation = Object.assign({})
          if (this.isAlter) {
            this.getRoleMenus(editUser.id)
            this.getUserRoleForm(editUser.id)
          } else {
            this.menuData = JSON.parse(this.storeMenu)
            this.roleMenus = JSON.parse(this.storeMenu)
          }
        })
      }
    },
    handleMessageTips(message, type) {
      let className = `.el-message.el-message--${type}`
      if (!document.querySelector(className)) {
        this.$message({
          message: message,
          type: type,
          duration: 3000
        })
      }
    },
    // add role dialog -- operation auth
    async getRoleMenus(id) {
      let params = {
        id: id
      }
      let { status, data } = await APIS.getRoleMenus({ data: params })
      if (status === 0 && data && data.length !== 0) {
        this.roleMenus = data
      } else {
        this.roleMenus = []
      }
    },
    async getRoleMenusOperations(menuId) {
      menuId = menuId || this.roleMenus[0].id
      if (this.menusOperation[menuId]) {
        this.roleOperation = this.menusOperation[menuId]
        return
      }
      let params = {
        id: this.isAlter ? this.selectedData[0] || 0 : 0,
        menuId: menuId
      }
      let { status, data } = await APIS.getRoleMenusOperations({ data: params })
      if (status === 0) {
        this.roleOperation = []
        let selectedOperationIds = data.selectedOperationIds.split(',')
        // 增加公共操作分组
        if (data.commonOperations.length) {
          this.roleOperation.push({
            name: '公共操作',
            operationArr: data.commonOperations,
            isCheckedAll: false,
            checkedOperation: [],
            isIndeterminate: false,
            id: -1
          })
          data.commonOperations.forEach((operationItem) => {
            // 判断操作是否被选中，选中操作放到checked arr中
            selectedOperationIds.forEach((item) => {
              if (item == operationItem.id) {
                this.roleOperation[0].checkedOperation.push(operationItem.name)
                this.roleOperation[0].indeterminate = true
              }
            })
          })
        }
        // 增加自定义分组
        data.operationGroups.forEach((item) => {
          this.roleOperation.push({
            name: item.name,
            operationArr: [],
            isCheckedAll: false,
            checkedOperation: [],
            isIndeterminate: false,
            id: item.id
          })
        })
        // 自定义分组增加操作
        data.groupOperations.forEach((operationItem) => {
          this.roleOperation.forEach((groupItem) => {
            if (operationItem.pId === groupItem.id) {
              // 将操作添加到对应的分组里
              groupItem.operationArr.push(operationItem)
              // 判断操作是否被选中，选中操作放到checked arr中
              selectedOperationIds.forEach((item) => {
                if (item == operationItem.id) {
                  groupItem.checkedOperation.push(operationItem.name)
                  groupItem.indeterminate = true
                }
              })
            }
          })
        })
        // 判断全选
        this.roleOperation.forEach((item) => {
          let checkedLength = item.checkedOperation.length
          let length = item.operationArr.length
          if (checkedLength === length) {
            item.isCheckedAll = true
            item.isIndeterminate = false
          } else if (checkedLength > 0) {
            item.isCheckedAll = false
            item.isIndeterminate = true
          } else {
            item.isCheckedAll = false
            item.isIndeterminate = false
          }
        })
        console.log(this.roleOperation)
        this.menusOperation[menuId] = this.roleOperation
      } else {
      }
    },
    getOperationIds(data) {
      let operationIds = []
      data.forEach((group) => {
        // 循环分组里的每一个操作
        group.operationArr.forEach((operationItem) => {
          // 循环分组中被选中的操作
          group.checkedOperation.forEach((checkedItem) => {
            // 找到被选中的操作，获取id，存入arr
            if (checkedItem === operationItem.name) {
              operationIds.push(operationItem.id)
            }
          })
        })
      })
      return operationIds
    }
  }
}
</script>

<style lang="scss" scoped>
.cy-user-manage {
  .content {
    @extend .comBackground;
    .operation-btns {
      width: 100%;
      padding: 20px 15px 0;
      button {
        border-color: #e7e7e7 !important;
      }
    }
  }
  .content .operation-btns {
    display: flex;
    padding: 10px 30px;
    align-items: center;
    border-bottom: 1px solid #edf0f7;
    button {
      width: 90px;
      height: 30px;
      margin: 0 10px 0 0;
      background: rgba(255, 255, 255, 1);

      border-radius: 5px;
      &.active,
      &:hover {
        color: #4397eb;
        border-color: #4397eb;
      }
      &.is-disabled {
        &.active,
        &:hover {
          color: #999;
          border-color: #e7e7e7;
        }
      }
    }
  }
  .list {
    padding: 0 15px;
  }
  /deep/ .el-pagination {
    margin: 15px 0;
    text-align: center;
    .el-pager {
      li {
        background-color: #ffffff;
      }
    }
    .btn-prev,
    .btn-next {
      background-color: #ffffff;
    }
    .total {
      font-size: 12px;
      font-weight: normal;
      margin-right: 10px;
      em {
        padding: 0 2px;
        color: #4497ec;
        font-style: normal;
      }
    }
  }
}
/deep/ .cy-dialog-common {
  .delete-icon-box {
    display: none;
  }
  .delete-text {
    padding: 30px 0 20px;
    text-align: center;
  }
  .el-dialog__footer {
    margin-top: 0;
  }
}
</style>
